import type { ReactNode } from 'react';

export const AssetsTableRowWrapper = ({
  children,
}: {
  children: ReactNode;
}) => <div className="py-3 hover:bg-ds-natural-50">{children}</div>;
